import { render } from "./PopUpNotAllowed.vue?vue&type=template&id=5effb58d"
import script from "./PopUpNotAllowed.vue?vue&type=script&lang=js"
export * from "./PopUpNotAllowed.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__